import { ICheckboxItem } from 'packages/ui-react/src/components/controls/CheckboxList';

import { IFullBuyTariff } from '~/src/features/full-buy/store/tariffTransformer';

export const toggleFilter = (id: string, filters: ICheckboxItem[]): ICheckboxItem[] => {
    const currElem = filters.find(el => el.id === id);

    if (currElem) {
        currElem.checked = !currElem.checked;

        return [
            ...filters,
        ];
    }

    return filters;
};

const getFilterTags = (tariffs: IFullBuyTariff[]) => {
    if (!tariffs) {
        return [];
    }

    const tagsSet = tariffs.reduce((mySet, tariff) => {
        tariff.tariffTags.forEach(mySet.add, mySet);
        return mySet;
    }, new Set<string>([]));

    return [...tagsSet].sort();
};

export const getFiltersFromTariffsTag = (tariffs: IFullBuyTariff[], currentFilters: ICheckboxItem[], currTariffs: IFullBuyTariff[] = []): ICheckboxItem[] => {
    const tags = getFilterTags(tariffs);

    return tags.map((tag) => {
        const curr = currentFilters.find(el => el.id === tag);

        return ({
            id: tag,
            checked: curr ? curr.checked : false,
            disabled: currTariffs.length > 0 ? currTariffs.every((tariff) => tariff.tariffTags.includes(tag)) : false,
            label: tag,
        });
    });
};

export const getTariffsFilteredByTags = (tariffs: IFullBuyTariff[], filters: ICheckboxItem[]) => {
    let _tariffs: IFullBuyTariff[] = tariffs;

    filters.forEach((filter) => {
        if (filter.checked) {
            _tariffs = _tariffs.filter(el => el.tariffTags.includes(filter.id));
        }
    });

    return _tariffs;
};

export const getTariffsFilteredByType = (tariffs: IFullBuyTariff[], isMono: boolean) => {
    return tariffs.filter(el => el.isMono === isMono);
};
